import { render } from "./BurstCollector.vue?vue&type=template&id=a777cad0&scoped=true&ts=true"
import script from "./BurstCollector.vue?vue&type=script&lang=ts"
export * from "./BurstCollector.vue?vue&type=script&lang=ts"

import "./BurstCollector.vue?vue&type=style&index=0&id=a777cad0&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a777cad0"]])

export default __exports__